<template>
  <div class="px-[24px] pt-[16px] pb-[16px] font-[Inter]" :class="{ 'pt-[92px]': isIos() }">
    <div class="relative">
      <img
        class="z-10 absolute right-[-40px] top-[25px] w-[70px] h-[70px]"
        src="/assets/images/register/hogc-stamp.png"
      />
      <h2
        class="z-30 text-center font-semibold pt-[48px] text-text-heading mb-[24px] text-brown-800 capitalize"
      >
        Welcome,
        {{
          register.preferredName !== null ? ` ${register.preferredName}` : ` ${register.givenName}`
        }}
      </h2>
      <h4 class="details-header text-center text-brown-800 mb-[40px]">
        You are all set.<br />
        Finally!
      </h4>
    </div>

    <div
      class="mx-2 mb-3 bg-white/40 flex flex-col text-left py-4 px-6 backdrop-blur-[20px] border-[1px] border-white rounded-[20px]"
    >
      <h3 class="font-bold text-text-body-md text-brown-800 mb-[24px]">When you’re in, you may:</h3>
      <h3 class="font-bold text-text-body-md text-brown-800 mb-1">✅ Turn on notifications</h3>
      <p class="text-text-body-md text-brown-800 mb-[24px]">
        To get real-time updates, reminders and more!
      </p>
      <h3 class="font-bold text-text-body-md text-brown-800 mb-1">✅ Allow activity tracking</h3>
      <p class="text-text-body-md text-brown-800 mb-[24px]">For a better app experience.</p>
      <h3 class="font-bold text-text-body-md text-brown-800 mb-1">✅ Keep your profile updated</h3>
      <p class="text-text-body-md text-brown-800">
        For personalised updates and a seamless experience!
      </p>
    </div>

    <DsButton
      variant="secondary"
      shape="pill"
      size="56"
      class="mt-[32px] w-full !text-text-body-md"
      @click="handleClick"
    >
      Let's go
    </DsButton>
  </div>
</template>

<script>
import { Button as DsButton } from '@team-hogc/hogc-one-design-system';
import {
  requestNotificationPermission,
  canRequestNotificationsPermission,
} from '@/utils/notification';
import { oneSignalExternalId } from '@/utils/onesignal-external-id';
import { requestTrackingPermission } from '@/utils/app-tracking';
import { mapState } from 'vuex';
import { isIosNativeOnly } from '@/utils/platform-check';
import { clearPendingDeepLinkRoute, getPendingDeepLinkRoute } from '@/utils/deeplink';

export default {
  components: {
    DsButton,
  },
  computed: {
    ...mapState('profile', {
      formloading: state => state.loading,
      memberId: state => state.id,
      register: state => state.register,
      errorMessages: state => state.errorMessages,
    }),
    notificationMemberId() {
      return (
        this.memberId ||
        oneSignalExternalId(this.$store.state.profile) ||
        this.register?.memberId ||
        this.register?.id ||
        this.register?.userId
      );
    },
  },

  methods: {
    isIos() {
      return isIosNativeOnly();
    },
    async handleClick() {
      if (await canRequestNotificationsPermission(this.notificationMemberId)) {
        await requestNotificationPermission(this.notificationMemberId);
        await new Promise(resolve => setTimeout(resolve, 1000));
        await requestTrackingPermission();
      } else {
        await requestTrackingPermission();
      }
      const pendingDeepLinkRoute = getPendingDeepLinkRoute();
      if (pendingDeepLinkRoute) {
        await this.$router.push(pendingDeepLinkRoute);
        clearPendingDeepLinkRoute();
        return;
      }

      this.$router.push('/home');
    },
  },
};
</script>

<style scoped>
.details-header {
  font-weight: 900;
  font-size: 44px;
  line-height: 48px;
  letter-spacing: -5%;
  text-align: center;
}
</style>
